import { render, staticRenderFns } from "./mocktemplate.vue?vue&type=template&id=8d905cea&"
import script from "./mocktemplate.vue?vue&type=script&lang=js&"
export * from "./mocktemplate.vue?vue&type=script&lang=js&"
import style0 from "./mocktemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports